export var ModalStyles = function ModalStyles(props) {
  var theme = props.theme;

  if (!theme) {
    throw new Error('Theme is undefined or null.');
  }

  var effects = theme.effects;
  return {
    main: {
      boxShadow: effects.elevation64,
      borderRadius: effects.roundedCorner2
    }
  };
};